"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = RawItem;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Option = _interopRequireDefault(require("../Option"));

/**

This component let the consumer to write `<ListBox.Option preventDefaultOnSelect />`
in a more semantic way:

<ListBox>
  <ListBox.Option>Option 1</ListBox.Option>
  <ListBox.RawItem> this is not interactive and can be anything </ListBox.RawItem>
</ListBox>

see: GetTypeOfChildren.js
*/
var propTypes = {
  preventDefaultOnSelect: _propTypes["default"].bool
};
var defaultProps = {
  preventDefaultOnSelect: true
};

function RawItem(props) {
  return /*#__PURE__*/_react["default"].createElement(_Option["default"], props);
}

RawItem.displayName = "ListBox.RawItem";
RawItem.propTypes = propTypes;
RawItem.defaultProps = defaultProps;
//# sourceMappingURL=RawItem.js.map